module.exports = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "conversations-visitor-ui": "static-1.24953",
      "ably": "static-2.2",
      "conversations-async-data": "static-2.5853",
      "conversations-error-reporting": "static-1.7040",
      "conversations-internal-pub-sub": "static-1.14139",
      "conversations-internal-schema": "static-1.10790",
      "conversations-message-history": "static-1.9224",
      "conversations-test-sdk": "static-1.8654",
      "conversations-visitor-experience-components": "static-1.18315",
      "head-dlb": "static-1.3234",
      "hs-promise-utils": "static-1.3664",
      "hs-test-utils": "static-1.6160",
      "hubspot-dlb": "static-2.949",
      "HubStyleTokens": "static-2.9692",
      "I18n": "static-7.1337",
      "jasmine-immutable": "static-1.1193",
      "jasmine-runner": "static-1.4556",
      "quartz": "static-1.4900",
      "react-aria": "static-1.36",
      "react-dlb": "static-1.46",
      "react-transition-group": "static-2.8",
      "redux-thunk": "static-2.43",
      "transmute": "static-2.29",
      "urlinator": "static-1.2751",
      "viral-links-lib": "static-1.4979",
      "visitor-ui-component-library": "static-1.4352",
      "webpack-env": "static-1.54",
      "ably-hubspot-js": "static-2.2770",
      "atom": "static-1.3508",
      "autolinker": "static-3.11",
      "classnames": "static-2.10",
      "conversations-http": "static-1.2961",
      "conversations-infrastructure": "static-1.7085",
      "conversations-prop-types": "static-1.5615",
      "conversations-visibility-tools": "static-1.3961",
      "conversations-visitor-message-history": "static-1.17052",
      "cssUtils": "static-1.351",
      "enviro": "static-4.284",
      "flux-actions": "static-1.259",
      "hs-lodash": "static-4.40",
      "hub-http": "static-1.4150",
      "hubspot-url-utils": "static-1.2600",
      "immer": "static-1.33",
      "immutable": "static-2.19",
      "metrics-js": "static-1.7874",
      "PatternValidationJS": "static-1.437",
      "PortalIdParser": "static-2.263",
      "raven": "static-3.3936",
      "react": "static-7.147",
      "react-dom": "static-7.85",
      "react-redux": "static-7.16",
      "react-rhumb": "static-1.14770",
      "react-select-plus": "static-1.65",
      "react-utils": "static-2.3817",
      "redux": "static-4.16",
      "redux-toolkit": "static-1.7",
      "reselect": "static-2.16",
      "sanitize": "static-1.2554",
      "sanitize-text": "static-1.6374",
      "signup-constants": "static-1.15038",
      "styled-components": "static-2.40",
      "StyleGuideUI": "static-3.443",
      "usage-tracker": "static-1.5658",
      "usage-tracker-core": "static-1.5508",
      "usage-tracker-multi": "static-1.4072",
      "usage-tracker-public": "static-1.5469",
      "visitor-ui-component-library-icons": "static-1.4163",
      "hs-promise-rejection-tracking": "static-1.3563",
      "raven-hubspot": "static-1.4243",
      "hoist-non-react-statics": "static-3.9",
      "bend-plugin-trellis-migration": "static-1.1916",
      "moment": "static-3.26",
      "quartz-core": "static-1.4119",
      "react-immutable-proptypes": "static-2.8",
      "foundations-assets": "static-1.3070",
      "foundations-components": "static-1.5255",
      "foundations-theming": "static-1.2403",
      "UIComponents": "static-3.6641",
      "conversations-skeleton-state": "static-1.5586",
      "cv-backend-services": "static-1.1007",
      "icons": "static-2.589",
      "react-input-autosize": "static-2.17",
      "ui-images": "static-2.780",
      "permission-components": "static-1.3546",
      "react-virtualized": "static-2.71",
      "HeadJS": "static-2.537",
      "framer-motion": "static-1.38",
      "hs-test-utils-bend-plugin": "static-1.1271",
      "msw": "static-1.39",
      "testing-library": "static-1.118",
      "i18n-data": "static-1.193",
      "moment-timezone": "static-5.51",
      "jasmine": "static-4.2549",
      "quartz-core-utils": "static-1.1767",
      "signup-ui-url-generator": "static-2.6215",
      "HubStyle": "static-2.10001",
      "sassPrefix": "static-1.127",
      "csstype": "static-1.38",
      "history": "static-4.47",
      "usage-tracker-anonymous": "static-1.4075",
      "copilot-toolkit": "static-1.4172",
      "dispatcher": "static-1.108",
      "general-store": "static-6.20",
      "hub-http-janus": "static-1.606",
      "hub-http-shared-msw-handlers": "static-1.6306",
      "hubspotter-http": "static-1.3022",
      "hubspotter-http-shared-msw-handlers": "static-1.6304",
      "mobile-manifest-mixins": "static-1.308",
      "platform-navigation-bootstrap": "static-1.10376",
      "quick-fetch": "static-1.2224",
      "react-router-dom": "static-5.26",
      "ui-fonts": "static-1.329",
      "hs-story-utils": "static-1.7475",
      "bend-plugin-foundations-components": "static-1.1523",
      "floating-ui": "static-1.24",
      "tanstack-table": "static-1.23",
      "bend-plugin-foundations-theming": "static-1.886",
      "foundations-theming-base": "static-1.1388",
      "rpc-client-utils": "static-1.2923",
      "ts-schema": "static-1.2640",
      "chatspot-client-types": "static-1.7646",
      "chatspot-core": "static-1.13365",
      "platform-infra-nav-components": "static-1.6154"
    },
    "depPathPrefixes": {
      "conversations-visitor-ui": "/conversations-visitor-ui/static-1.24953",
      "ably": "/ably/static-2.2",
      "conversations-async-data": "/conversations-async-data/static-2.5853",
      "conversations-error-reporting": "/conversations-error-reporting/static-1.7040",
      "conversations-internal-pub-sub": "/conversations-internal-pub-sub/static-1.14139",
      "conversations-internal-schema": "/conversations-internal-schema/static-1.10790",
      "conversations-message-history": "/conversations-message-history/static-1.9224",
      "conversations-test-sdk": "/conversations-test-sdk/static-1.8654",
      "conversations-visitor-experience-components": "/conversations-visitor-experience-components/static-1.18315",
      "head-dlb": "/head-dlb/static-1.3234",
      "hs-promise-utils": "/hs-promise-utils/static-1.3664",
      "hs-test-utils": "/hs-test-utils/static-1.6160",
      "hubspot-dlb": "/hubspot-dlb/static-2.949",
      "HubStyleTokens": "/HubStyleTokens/static-2.9692",
      "I18n": "/I18n/static-7.1337",
      "jasmine-immutable": "/jasmine-immutable/static-1.1193",
      "jasmine-runner": "/jasmine-runner/static-1.4556",
      "quartz": "/quartz/static-1.4900",
      "react-aria": "/react-aria/static-1.36",
      "react-dlb": "/react-dlb/static-1.46",
      "react-transition-group": "/react-transition-group/static-2.8",
      "redux-thunk": "/redux-thunk/static-2.43",
      "transmute": "/transmute/static-2.29",
      "urlinator": "/urlinator/static-1.2751",
      "viral-links-lib": "/viral-links-lib/static-1.4979",
      "visitor-ui-component-library": "/visitor-ui-component-library/static-1.4352",
      "webpack-env": "/webpack-env/static-1.54",
      "ably-hubspot-js": "/ably-hubspot-js/static-2.2770",
      "atom": "/atom/static-1.3508",
      "autolinker": "/autolinker/static-3.11",
      "classnames": "/classnames/static-2.10",
      "conversations-http": "/conversations-http/static-1.2961",
      "conversations-infrastructure": "/conversations-infrastructure/static-1.7085",
      "conversations-prop-types": "/conversations-prop-types/static-1.5615",
      "conversations-visibility-tools": "/conversations-visibility-tools/static-1.3961",
      "conversations-visitor-message-history": "/conversations-visitor-message-history/static-1.17052",
      "cssUtils": "/cssUtils/static-1.351",
      "enviro": "/enviro/static-4.284",
      "flux-actions": "/flux-actions/static-1.259",
      "hs-lodash": "/hs-lodash/static-4.40",
      "hub-http": "/hub-http/static-1.4150",
      "hubspot-url-utils": "/hubspot-url-utils/static-1.2600",
      "immer": "/immer/static-1.33",
      "immutable": "/immutable/static-2.19",
      "metrics-js": "/metrics-js/static-1.7874",
      "PatternValidationJS": "/PatternValidationJS/static-1.437",
      "PortalIdParser": "/PortalIdParser/static-2.263",
      "raven": "/raven/static-3.3936",
      "react": "/react/static-7.147",
      "react-dom": "/react-dom/static-7.85",
      "react-redux": "/react-redux/static-7.16",
      "react-rhumb": "/react-rhumb/static-1.14770",
      "react-select-plus": "/react-select-plus/static-1.65",
      "react-utils": "/react-utils/static-2.3817",
      "redux": "/redux/static-4.16",
      "redux-toolkit": "/redux-toolkit/static-1.7",
      "reselect": "/reselect/static-2.16",
      "sanitize": "/sanitize/static-1.2554",
      "sanitize-text": "/sanitize-text/static-1.6374",
      "signup-constants": "/signup-constants/static-1.15038",
      "styled-components": "/styled-components/static-2.40",
      "StyleGuideUI": "/StyleGuideUI/static-3.443",
      "usage-tracker": "/usage-tracker/static-1.5658",
      "usage-tracker-core": "/usage-tracker-core/static-1.5508",
      "usage-tracker-multi": "/usage-tracker-multi/static-1.4072",
      "usage-tracker-public": "/usage-tracker-public/static-1.5469",
      "visitor-ui-component-library-icons": "/visitor-ui-component-library-icons/static-1.4163",
      "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.3563",
      "raven-hubspot": "/raven-hubspot/static-1.4243",
      "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
      "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.1916",
      "moment": "/moment/static-3.26",
      "quartz-core": "/quartz-core/static-1.4119",
      "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
      "foundations-assets": "/foundations-assets/static-1.3070",
      "foundations-components": "/foundations-components/static-1.5255",
      "foundations-theming": "/foundations-theming/static-1.2403",
      "UIComponents": "/UIComponents/static-3.6641",
      "conversations-skeleton-state": "/conversations-skeleton-state/static-1.5586",
      "cv-backend-services": "/cv-backend-services/static-1.1007",
      "icons": "/icons/static-2.589",
      "react-input-autosize": "/react-input-autosize/static-2.17",
      "ui-images": "/ui-images/static-2.780",
      "permission-components": "/permission-components/static-1.3546",
      "react-virtualized": "/react-virtualized/static-2.71",
      "HeadJS": "/HeadJS/static-2.537",
      "framer-motion": "/framer-motion/static-1.38",
      "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.1271",
      "msw": "/msw/static-1.39",
      "testing-library": "/testing-library/static-1.118",
      "i18n-data": "/i18n-data/static-1.193",
      "moment-timezone": "/moment-timezone/static-5.51",
      "jasmine": "/jasmine/static-4.2549",
      "quartz-core-utils": "/quartz-core-utils/static-1.1767",
      "signup-ui-url-generator": "/signup-ui-url-generator/static-2.6215",
      "HubStyle": "/HubStyle/static-2.10001",
      "sassPrefix": "/sassPrefix/static-1.127",
      "csstype": "/csstype/static-1.38",
      "history": "/history/static-4.47",
      "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.4075",
      "copilot-toolkit": "/copilot-toolkit/static-1.4172",
      "dispatcher": "/dispatcher/static-1.108",
      "general-store": "/general-store/static-6.20",
      "hub-http-janus": "/hub-http-janus/static-1.606",
      "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.6306",
      "hubspotter-http": "/hubspotter-http/static-1.3022",
      "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.6304",
      "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.308",
      "platform-navigation-bootstrap": "/platform-navigation-bootstrap/static-1.10376",
      "quick-fetch": "/quick-fetch/static-1.2224",
      "react-router-dom": "/react-router-dom/static-5.26",
      "ui-fonts": "/ui-fonts/static-1.329",
      "hs-story-utils": "/hs-story-utils/static-1.7475",
      "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.1523",
      "floating-ui": "/floating-ui/static-1.24",
      "tanstack-table": "/tanstack-table/static-1.23",
      "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.886",
      "foundations-theming-base": "/foundations-theming-base/static-1.1388",
      "rpc-client-utils": "/rpc-client-utils/static-1.2923",
      "ts-schema": "/ts-schema/static-1.2640",
      "chatspot-client-types": "/chatspot-client-types/static-1.7646",
      "chatspot-core": "/chatspot-core/static-1.13365",
      "platform-infra-nav-components": "/platform-infra-nav-components/static-1.6154"
    },
    "project": "conversations-visitor-ui",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};